module.exports = __webpack_public_path__ + "static/media/rgb.f88729bd.png";